"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = __importDefault(require("styled-components"));
var Utility_1 = require("../Utility");
var StyledPrice = (0, styled_components_1.default)(function (_a) {
    var className = _a.className, rest = _a.rest;
    return React.createElement("div", __assign({ className: className }, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.t2-price {\n    ", "\n    ", "\n    ", "\n  }\n"], ["\n  &.t2-price {\n    ", "\n    ", "\n    ", "\n  }\n"])), function (props) {
    return props.align === 'left' &&
        "\n    align-items: flex-start;\n    ";
}, function (props) {
    return props.align === 'center' &&
        "\n    align-items: center;\n    ";
}, function (props) {
    return props.align === 'right' &&
        "\n    align-items: flex-end;\n    ";
});
var Price = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), _b = _a.align, align = _b === void 0 ? 'right' : _b, className = _a.className, rest = __rest(_a, ["align", "className"]);
    return (React.createElement(StyledPrice, { align: align, className: (0, classnames_1.default)('t2-price', "t2-price-align-".concat(align), className), rest: rest }));
};
exports.default = Price;
var templateObject_1;
